import { useState } from 'react';
import styles from './HomeSlider.module.scss';
import NewsTopHeader from '../../Molecules/TableTopHeader/NewsTopHeader';
import Buttons from '../../Atoms/Buttons/Buttons';
import HomeSliderCard from '../../Molecules/HomeSlider/HomeSliderCard';
import { useFetchHomePage } from '../../../Hooks/HomeSlider';
import { useNavigate } from 'react-router-dom';
import ReorderModal from '../../Molecules/HomeSlider/ReorderModal';
import Loader from '../../Molecules/Loader/Loader';

const HomeSliderPage = () => {
  const [search, setSearch] = useState('');
  const [showReorderModal, setShowReorderModal] = useState(false);
  const { data: homeSliders, refetch, isLoading } = useFetchHomePage();
  const navigate = useNavigate();

  return (
    <div className={styles['slider-page']}>
      <NewsTopHeader
        search={search}
        setSearch={setSearch}
        handleNewClick={() => {
          navigate('/home/add-home-slider');
        }}
        type='gallery'
        actionButtons={
          <Buttons
            text='إعادة ترتيب'
            rounded={true}
            handleOnClick={() => {
              setShowReorderModal(true);
            }}
            color='rgba(13, 160, 110, 1)'
          />
        }
      />
      <div className={styles['table-container']}>
        {isLoading ? (
          <Loader />
        ) : homeSliders?.data ? (
          homeSliders?.data.map((item) => (
            <HomeSliderCard item={item} refetch={refetch} key={item?.id} />
          ))
        ) : (
          <div></div>
        )}
      </div>
      {showReorderModal && (
        <ReorderModal
          refetch={refetch}
          handleOnClose={() => setShowReorderModal(false)}
          items={homeSliders?.data}
        />
      )}
    </div>
  );
};

export default HomeSliderPage;
